// [EDITED: KPI Task - Mahesh Sharma]
import moment from 'moment-timezone'; // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Checks whether KPI submission or rating is locked for a given week.
 * Rule:
 * - Admin and Super Admin roles are completely exempt.
 * - Lock is ONLY active on Mondays (all day, 00:00 to 23:59 IST) for PAST weeks' KPIs.
 * - Current week's KPI (the week starting that Monday) is open even on Monday.
 * - Tuesday through Sunday are completely open for all weeks.
 *
 * @param {string|Date} weekInput - The week identifier or date
 * @param {string} userRole - User's role
 * @returns {boolean} - true if locked, false if open
 */
export function isKPILockedFrontend(weekInput, userRole) { // [EDITED: KPI Task - Mahesh Sharma]
  const role = (userRole || '').toString().toLowerCase(); // [EDITED: KPI Task - Mahesh Sharma]
  if (role === 'admin' || role === 'super_admin' || role === 'administrator') { // [EDITED: KPI Task - Mahesh Sharma]
    return false; // Admin is exempt from lockout // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]

  const now = moment().tz('Asia/Kolkata'); // [EDITED: KPI Task - Mahesh Sharma]

  // If today is NOT Monday (isoWeekday: 1 = Monday, 7 = Sunday), lockout is NOT active // [EDITED: KPI Task - Mahesh Sharma]
  if (now.isoWeekday() !== 1) { // [EDITED: KPI Task - Mahesh Sharma]
    return false; // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]

  // Today is Monday. Determine if target week is a previous week // [EDITED: KPI Task - Mahesh Sharma]
  let targetWeekEnd; // [EDITED: KPI Task - Mahesh Sharma]
  if (typeof weekInput === 'string' && weekInput.includes('W')) { // [EDITED: KPI Task - Mahesh Sharma]
    const parts = weekInput.split('W'); // [EDITED: KPI Task - Mahesh Sharma]
    const year = parseInt(parts[0].replace(/[^0-9]/g, ''), 10); // [EDITED: KPI Task - Mahesh Sharma]
    const weekNo = parseInt(parts[1], 10); // [EDITED: KPI Task - Mahesh Sharma]
    targetWeekEnd = moment().tz('Asia/Kolkata').isoWeekYear(year).isoWeek(weekNo).endOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  } else if (weekInput) { // [EDITED: KPI Task - Mahesh Sharma]
    targetWeekEnd = moment(weekInput).tz('Asia/Kolkata').endOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  } else { // [EDITED: KPI Task - Mahesh Sharma]
    targetWeekEnd = moment(now).endOf('isoWeek'); // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]

  // Start of this Monday in IST (00:00:00) // [EDITED: KPI Task - Mahesh Sharma]
  const startOfMonday = moment(now).startOf('day'); // [EDITED: KPI Task - Mahesh Sharma]

  // If the target week ended before this Monday (e.g. Sunday 23:59:59), it's a previous week and locked on Monday // [EDITED: KPI Task - Mahesh Sharma]
  return targetWeekEnd.isBefore(startOfMonday); // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]
